import { render } from "./comingsoon_image.vue?vue&type=template&id=8957b2ca"
import script from "./comingsoon_image.vue?vue&type=script&lang=js"
export * from "./comingsoon_image.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__